module.exports = __webpack_public_path__ + "img/microsoft.a8720322.svg";